import { KeyValueMap } from "../../components.props";

export interface SelectionProps {
  show?: boolean;
  id: string;
  placeholder?: string;
  className?: string;
  items: SelectionItemProps[];
  selected: SelectionItemProps;
  onSelect: (selected: SelectionItemProps, id: string) => void;
  error?: string;
  disabled?: boolean;
}

export interface SelectionItemProps {
  key: string;
  text: string;
}

export function buildFilterObject(
  filterKey: string,
  filters: KeyValueMap,
  items: SelectionItemProps[] = []
): SelectionItemProps {
  const value = filters[filterKey];
  if (!value?.length) {
    return { key: "", text: "" };
  }

  // Resuelve la etiqueta traducida del item seleccionado en vez de mostrar
  // el valor interno guardado (p.ej. "expired") como si fuera el texto.
  const match = items.find((item) => item.key === value);
  return match ?? { key: value, text: value };
}
